@use "../../../sass/global/global" as *;
@use "../mixins";

/* stylelint-disable selector-max-id */
/**
@prop --menu-item-background-color: background color of the menu item
@prop --menu-item-background-color-hover: background color of the menu item on hover
@prop --menu-item-text-color: text color of the menu item
@prop --menu-item-text-color-active: text color of the menu item when active
@prop --menu-item-text-color-disabled: text color of the menu item when disabled
@prop --menu-item-min-height: minimum height of the menu item
@prop --menu-item-min-width: minimum width of the menu item
@prop --menu-item-font-size: font size of the menu item
@prop --menu-item-font-weight: font weight of the menu item
@prop --menu-item-line-height: line height of the menu item
@prop --menu-item-divider-color: color of the menu item divider
 */
:root {
    @include mixins.menu-item(vars);
}

:host {
    display: block;
    box-sizing: border-box;
    position: relative;
    background: var(--menu-item-background-color, #f2f3f6);

    #button {
        @include mixins.menu-item(item);
        appearance: none;
        width: 100%;

        &:hover {
            @include mixins.menu-item(hover);
        }

        &:focus,
        &:focus-visible {
            @include mixins.menu-item(focus);
        }
    }

    #label {
        flex: 1 1 auto;
    }

    .is-hidden {
        display: none;
    }

    .submenu {
        display: none;
    }
}

:host([level="0"]:first-of-type) #button::before {
    @include mixins.menu-item(separator);
    top: 0;
    margin-top: -1px;
}

:host #button::after {
    @include mixins.menu-item(separator);
    top: 100%;
    margin-top: -1px;
}

:host([expanded]) .submenu {
    display: block;
}

:host([level="1"]) #button,
:host([level="2"]) #button,
:host([level="3"]) #button {
    padding-left: 60px;
}

:host([current]:not([current="false"])) #button,
:host([current-child]:not([current-child="false"]):not([expanded])) #button {
    @include mixins.menu-item(current);
}
